/**
 * @author Toru Nagashima <https://github.com/mysticatea>
 * @copyright 2017 Toru Nagashima. All rights reserved.
 * See LICENSE file in root directory for full license.
 */
import debugFactory from 'debug';
export const debug = debugFactory('cml-eslint-parser');
